// extracted by mini-css-extract-plugin
export default {"wrap":"Partners_wrap__KQwkw","title":"Partners_title__3Zc9e","header":"Partners_header__6jvwq","subtitle":"Partners_subtitle__h+oTV","images-wrap":"Partners_images-wrap__v7izk"};